var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4175 0.732422C19.6858 2.5546 18.9441 4.33973 17.9657 5.60273C16.9189 6.95746 15.1146 8.00526 13.3665 7.95057C13.0474 6.20601 13.8644 4.40853 14.8586 3.20021C15.9492 1.86665 17.8184 0.843552 19.4175 0.732422ZM24.6689 26.3806C25.5702 24.9994 25.9068 24.3027 26.6064 22.7433C21.5181 20.8083 20.7027 13.5742 25.7385 10.7977C24.2025 8.87149 22.0441 7.7549 20.0066 7.7549C18.5385 7.7549 17.5327 8.13801 16.6182 8.4863C15.8562 8.77654 15.1577 9.04259 14.308 9.04259C13.3899 9.04259 12.5769 8.75108 11.7256 8.44583C10.7901 8.11042 9.80836 7.75843 8.59019 7.75843C6.30374 7.75843 3.87001 9.15549 2.32702 11.5439C0.158052 14.9078 0.528021 21.2316 4.04536 26.6188C5.30255 28.5468 6.98231 30.7129 9.17933 30.7323C10.091 30.7414 10.6976 30.4693 11.354 30.1749C12.1054 29.8379 12.9221 29.4716 14.3361 29.464C15.7584 29.4555 16.5622 29.8263 17.3036 30.1682C17.9432 30.4632 18.5364 30.7368 19.4403 30.727C21.639 30.7094 23.4117 28.3086 24.6689 26.3806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.4a9f8935.svg";
export { ForwardRef as ReactComponent };